import {route} from '@/router/route-utils'

const prefix = '/admin/mailings';

const routes = [

    route(
        prefix, 'admin.mailings.list', {
            components : {
                main: () => import('./views/AdminMailingsListView')
            },
            requiresAuth: true,
            layout: 'LayoutFull',
            title: 'Mailings',
            breadcrumb: [
                {text: 'Mailings', active: true},
            ],
        }
    ),
];

export default routes
